import {
  InfiniteScrollDataTable,
  DataTableSearch,
  Typography,
  Loading,
  Button,
} from '@ui/components';
import { useTranslation, Trans } from 'react-i18next';
import { Refresh } from '@ui/components/icons';
import { useState } from 'react';

import { ParkingStopDialog } from '../parking-spot-stop-dialog/parking-spot-stop-dialog';
import { useParkingSpotsTable } from './use-parking-spots-table';

export const ParkingSpotsTable = () => {
  const { t } = useTranslation();
  const [stopParkingSpotId, setStopParkingSpotId] = useState<string | false>(false);

  const {
    isTableConfigLoading,
    fetchNextPage,
    columnsLength,
    globalFilter,
    refetchTable,
    hasNextPage,
    totalItems,
    isFetching,
    resetTable,
    isLoading,
    table,
  } = useParkingSpotsTable({
    onStopParking: (parkingId: string) => {
      setStopParkingSpotId(parkingId);
    },
  });

  return (
    <div className="bg-table-background rounded-lg overflow-hidden mb-8 flex flex-col">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('PARKING_SPOTS.TABLE_TOTAL_PARKINGS', { count: totalItems })}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTableSearch
            placeholder={t('PARKING_SPOTS.TABLE_SEARCH_PLACEHOLDER')}
            onChange={table.setGlobalFilter}
            value={globalFilter}
          />
          <Button
            onClick={() => resetTable()}
            isLoading={isLoading}
            disabled={isLoading}
            variant="tertiary"
            className="w-50"
            icon
            wide
          >
            <Refresh />
            {t('PARKING_SPOTS.TABLE_REFRESH')}
          </Button>
        </div>
      </div>
      <Loading isLoading={isTableConfigLoading}>
        <InfiniteScrollDataTable
          noResultsComponent={
            <Typography variant="labelMediumBook">
              <Trans i18nKey="PARKING_SPOTS.TABLE_NO_RESULTS" />
            </Typography>
          }
          fetchNextPage={() => {
            fetchNextPage();
          }}
          columnsLength={columnsLength}
          className="flex-1 h-full"
          isFetching={isFetching}
          hasMore={hasNextPage}
          isLoading={isLoading}
          table={table}
        />
      </Loading>

      {stopParkingSpotId && (
        <ParkingStopDialog
          onClose={({ handleSubmit }) => {
            if (handleSubmit) {
              refetchTable();
            }
            setStopParkingSpotId(false);
          }}
          parkingSpotId={stopParkingSpotId}
          isOpen={!!stopParkingSpotId}
        />
      )}
    </div>
  );
};
